/**
 * Whether X-Ray may be ordered for a visit's care type.
 *
 * Per client: X-Ray is orderable only by Physician Care or Orthopedic Physician
 * Care — detected by the care-type (department) name. Matches the "nurse"/"ear"/
 * "hospital" substring convention used elsewhere.
 */
export const canOrderXRay = (typeOfCare?: string): boolean => {
  const ct = typeOfCare?.toLowerCase() || "";
  return ct.includes("physician") || ct.includes("orthopedic");
};
